<div class="table-menu-text centered-row-container width-100pcnt"
  [ngClass]="disabled ? 'disabled' : ''"
  (click)="itemClickEmitter()">
  <div class="table-menu-item width-100pcnt {{menuItemClass}}">
    <app-all-icons [iconNameAndStyling]="iconNameAndStyling"></app-all-icons>
    <span>{{text}}</span>
  </div>
</div>
